import { surveyEndpointIds } from 'root/src/shared/survey/constants';
import cronJobPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/cronJobPayloadSchema';
export const satisfactionSurveyLifecycleEndpoint = {
    [surveyEndpointIds.SATISFACTION_SURVEY_LIFECYCLE]: {
        payloadSchema: cronJobPayloadSchema,
        isCron: true,
        isLowSpec: true,
    },
};
